/**
 * Product PDP FAQ accordion only (metaobject list in product tabs).
 */
(function () {
  function bind(container) {
    if (!container || container.dataset.pdpFaqsBound === '1') return;
    container.dataset.pdpFaqsBound = '1';
    container.querySelectorAll('.faqs-entry').forEach(function (entry) {
      var button = entry.querySelector('.faqs__list__button');
      if (!button) return;
      button.addEventListener('click', function (e) {
        e.preventDefault();
        entry.classList.toggle('open');
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-pdp-product-faqs]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
